import { render, staticRenderFns } from "./cosmo.vue?vue&type=template&id=7e6aa504&"
import script from "./cosmo.vue?vue&type=script&lang=js&"
export * from "./cosmo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports